import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { DieselClient } from "@/features/billing/DieselClient";
import { dieselKeys, getDiesel } from "@/features/billing/diesel.api";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Commercie → Diesel (docs/tms-facturatie.md §14): reading is billing, entering a price and changing a method
// billing_write.
export const Route = createFileRoute("/_shell/billing/diesel")({
  beforeLoad: ({ context }) => {
    const { session } = context;
    if (!session.roles.includes("admin") && !hasModule(session, "billing") && !hasModule(session, "billing_write")) {
      throw redirect({ to: firstAllowedRoute(session) });
    }
  },
  component: DieselScreen,
});

function DieselScreen() {
  const { t } = useTranslation();
  const { session } = Route.useRouteContext();
  const query = useQuery({ queryKey: dieselKeys.overview(), queryFn: getDiesel });
  const canWrite = session.roles.includes("admin") || hasModule(session, "billing_write");

  return (
    <div className="wl-page" data-screen-label="Back-office Diesel">
      {query.error ? (
        <div className="wl-alert wl-alert--danger" role="alert">
          {query.error instanceof Error ? query.error.message : String(query.error)}
        </div>
      ) : query.data ? (
        <DieselClient data={query.data} canWrite={canWrite} />
      ) : (
        <span className="t-caption t-muted">{t("common.loading")}</span>
      )}
    </div>
  );
}
